
import { Button, ButtonBase, Checkbox } from '@mui/material';
import { React, useContext, useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';

import Modal from 'react-bootstrap/Modal';

import CheckIcon from '@mui/icons-material/Check';
import { SnackbarContext } from '../../../App';
import { useAuth } from 'react-oidc-context';

export default ({ show, onClose, clientId, users, initialSelectedUsers, onRefresh }) => {
  const auth = useAuth();

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  const [
    selectedUsers,
    setSelectedUsers,
  ] = useState(initialSelectedUsers);

  useEffect(() => {
    setSelectedUsers(initialSelectedUsers);
  }, [show]);

  async function saveSelectedUsers() {
    try {
      const response = await fetch(`${window.origin}/api/omni2/client/${clientId}/users`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth.user?.access_token}`,
        },
        body: JSON.stringify({
          users: selectedUsers,
        }),
      });

      if (response.status === 403) {
        setSessionExpired(true);
      } else if (!response.ok) {
        throw Error('Unexpected error occured');
      } else {
        onRefresh();
        setSnackBarMessage('Permission updated');
        setSnackBarShow(true);
      }
      onClose();
    } catch (error) {
      setSnackBarMessage('Unexpected error occured. Please try again later');
      setSnackBarShow(true);
      onClose();
    }
  }

  return (
    <Modal style={{ paddingTop: '10vh', color: 'rgb(0, 0, 0, .8)' }} dialogClassName="modal-30w" show={show} onHide={onClose}>
      <Modal.Header style={{ border: 0, color: '#ee7170', padding: 0 }}>
      </Modal.Header>
      <Modal.Body style={{ padding: '1vw', paddingTop: '2vw', textAlign: 'center' }}>
        <p style={{ fontWeight: '500', fontSize: '1vw', marginBottom: '1vw' }}>User Assignment</p>
        <div><p style={{ fontSize: '0.8vw', fontWeight: '400', marginBottom: '1vw' }}>Select users to allow access to this client</p></div>

        <div style={{ margin: '2vw 0.5vw 0vw 0.5vw', backgroundColor: 'rgb(0, 0, 0, 0.03)', borderRadius: '1vw', overflow: 'hidden', maxHeight: '40vh', overflowY: 'scroll' }}>

          {users.map(item => (
            <ButtonBase
              onClick={() => {
                console.log('clicked');
                if (selectedUsers.find(user => user.email == item.email)) {
                  setSelectedUsers((prevState) => {
                    console.log(prevState.filter(user => user.email != item.email));
                    return prevState.filter(user => user.email != item.email);
                  });
                } else {
                  setSelectedUsers((prevState) => {
                    return [
                      ...prevState,
                      item,
                    ];
                  });
                }
              }}
              style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', padding: '0.6vw 1.2vw', marginTop: '0', marginBottom: '0', width: '100%' }}
            >
              <div style={{ marginRight: '1vw' }}>
                <img width="2vw" src={`https://ui-avatars.com/api/?name=${item.firstName}+${item.lastName}`} style={{ width: '2vw', borderRadius: '50%' }} alt="User avatar" />
              </div>
              <div style={{ fontWeight: '500', fontSize: '0.8vw', flex: 1 }}>
                <p style={{ marginBottom: '0.1vw', textAlign: 'left', fontSize: '0.9vw' }}>
                  {item.firstName}
                  {' '}
                  {item.lastName}
                </p>
                <p style={{ margin: 0, textAlign: 'left', fontSize: '0.7vw', fontWeight: '400' }}>{item.email}</p>
              </div>
              <div style={{ justifySelf: 'flex-end' }}>
                { selectedUsers.find(user => user.email == item.email) && <CheckIcon style={{ fontSize: '1vw' }} />}
              </div>
            </ButtonBase>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ border: 0, alignItems: 'center', justifyContent: 'center', borderTop: '1px solid rgb(255, 255, 255, 0.1)', margin: '0.7vw' }}>

        <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
          <Button
            onClick={() => { onClose(false); }}
            variant="outlined"
            style={{ flex: 1,
              borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(0, 0, 0, 0.9)', padding: '0.5vw', border: 'none', backgroundColor: 'rgb(0, 0, 0, 0.07)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
              width: '100%', marginRight: '0.5vw' }}
          >
            Close
          </Button>
          <Button
            onClick={saveSelectedUsers}
            variant="outlined"
            style={{ flex: 1,
              borderColor: 'rgb(255, 255, 255, 1)', color: 'rgb(255, 255, 255, 0.9)', padding: '0.5vw', border: 'none', backgroundImage: 'linear-gradient(rgb(255, 255, 255, 0.05), rgb(10, 10, 10, 0.05)),linear-gradient(#1c6c6c, #1c6c6c)', borderRadius: '0.5vw', textTransform: 'none', fontSize: '1vw', fontWeight: 500, letterSpacing: '0.08vw',
              width: '100%' }}
          >
            Save
          </Button>

        </div>
      </Modal.Footer>
    </Modal>

  );
};
